var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronsDown = function SvgChevronsDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41074 15.5919C9.73618 15.9173 10.2638 15.9173 10.5893 15.5919L14.7559 11.4252C15.0814 11.0998 15.0814 10.5721 14.7559 10.2467C14.4305 9.92125 13.9028 9.92125 13.5774 10.2467L10 13.8241L6.42259 10.2467C6.09715 9.92125 5.56951 9.92125 5.24408 10.2467C4.91864 10.5721 4.91864 11.0998 5.24408 11.4252L9.41074 15.5919Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41074 9.75853C9.73618 10.084 10.2638 10.084 10.5893 9.75853L14.7559 5.59186C15.0814 5.26642 15.0814 4.73879 14.7559 4.41335C14.4305 4.08791 13.9028 4.08791 13.5774 4.41335L10 7.99076L6.42259 4.41335C6.09715 4.08791 5.56951 4.08791 5.24408 4.41335C4.91864 4.73879 4.91864 5.26642 5.24408 5.59186L9.41074 9.75853Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronsDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevrons-down.b5faeadda5e4a7f1ec5cc780036d4c34.svg";